import IconSvg from './assets/icons/32/info.svg';
import { FC } from 'react';
const Icon: FC = () => <img alt="info" src={IconSvg} width="32px" height="32px" />;

export default Icon;
